import { Popup } from 'components/common/popup/Popup';
import { Button, Stack } from '@mui/material';
import React, { useState } from 'react';
import useBundleTranslation from 'i18n';
import { TemplateFormComponent } from 'components/common/form/layout/ReactHookFormController';
import { FormDataAPIType } from 'components/common/form';
import useCustomSimplifiedForm from 'components/common/form/hooks/useCustomSimplifiedForm';
import { IKpiAlertRule } from '@report-content';
import FormComponent from 'components/common/form/Form';
import LoadingPlaceholder from 'components/common/loading-placeholder/LoadingPlaceholder';

export default function AddAlertRulePopup({
    elementId,
    isOpen,
    setIsOpen,
    allowedAlertRules,
    addedAlertRules,
    onConfirm,
    onNewAlertRuleCreated,
    alertRulesIsFetching,
}: {
    elementId: number;
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
    allowedAlertRules: IKpiAlertRule[];
    addedAlertRules: IKpiAlertRule[];
    onConfirm: (alertsList: number[]) => void;
    onNewAlertRuleCreated: () => void;
    alertRulesIsFetching: boolean;
}) {
    const { t } = useBundleTranslation(['components/report-content']);
    const elementProps: FormDataAPIType = useCustomSimplifiedForm();
    const [isFormOpen, setIsFormOpen] = useState(false);

    const createNewButton = (
        <Button variant="outlined" color="success" onClick={() => setIsFormOpen(true)}>
            {t('kpi_chart.create_new_alert_rule')}
        </Button>
    );

    return (
        <Popup
            onHide={() => setIsOpen(false)}
            open={isOpen}
            settings={{
                textOK: t('add'),
                title: t('kpi_chart.add_alert_rule'),
                // actionsPostContent: createNewButton,
            }}
            onConfirm={() => {
                let result: number[] = [];
                try {
                    const list = JSON.parse(elementProps.form.hookFormGetValues('alerts'));
                    if (Array.isArray(list)) {
                        result = [
                            ...addedAlertRules.map((r) => r.report_alert_rule_id),
                            ...list.map((id) => Number(id)),
                        ];
                    }
                } catch (e) {}
                onConfirm(result);
                setIsOpen(false);
            }}
        >
            <Stack spacing={1}>
                {alertRulesIsFetching && <LoadingPlaceholder />}
                <TemplateFormComponent
                    component={'CheckBoxList'}
                    elementProps={elementProps}
                    name={'alerts'}
                    props={{
                        data: {
                            values: allowedAlertRules
                                .filter(
                                    (r) =>
                                        !addedAlertRules.some((a) => a.report_alert_rule_id === r.report_alert_rule_id),
                                )
                                .map((r) => ({ value: r.report_alert_rule_id, label: r.name })),
                        },
                        emptyHeight: 75,
                        showCounter: false,
                        selectAllLabel: t('kpi_chart.rule_name'),
                        async: false,
                    }}
                />
            </Stack>
            {isFormOpen && (
                <FormComponent
                    pk={'add-report-alert-rule'}
                    uid={'add-report-alert-rule'}
                    settingsUrl={`/data/editor/element/report/${elementId}/alert-rule/0/form`}
                    popupType={'new'}
                    popupSettings={{ title: t('kpi_chart.add_alert_rule') }}
                    isPopup
                    onHide={() => setIsFormOpen(false)}
                    afterSave={() => {
                        setIsFormOpen(false);
                        onNewAlertRuleCreated();
                    }}
                />
            )}
        </Popup>
    );
}
